module.exports = __webpack_public_path__ + "static/media/flria shot 05.5e21c491.webp";